import { castToNumberData } from "./transformData";

const getUniqueValues = (arr, key) => {

  return [...new Set(arr.map((item) => item[key]))];
};




const treeTransformData = (data, boxKey, subBoxKey, valueKey, toolTipKeys) => {

  const valuearr = valueKey && valueKey.responseKey;
  const uniqueTootlTipKeys = toolTipKeys.map((item) => item.responseKey);
  const tooltipArray = [valuearr, ...uniqueTootlTipKeys]


  if (!valueKey || !boxKey) return null;
  if (!subBoxKey) {
    return castToNumberData(data, tooltipArray);
  } else {
    // Transform data to groups
    const transformedDataArray = [];
    // Get unique box values
    const uniqueBoxes = getUniqueValues(data, boxKey);

    uniqueBoxes.forEach((box) => {
      console.log(box);
      console.log(boxKey);
      console.log(uniqueBoxes);



      const boxObject = { [boxKey]: box, children: [] };
      console.log(boxObject);

      transformedDataArray.push(boxObject);
    });

    data.forEach((dataObject) => {
      const boxValue = dataObject[boxKey];
      const indexBoxValue = transformedDataArray.findIndex(
        (uniqueBox) => uniqueBox[boxKey] === boxValue

      );
      if (indexBoxValue < 0) {
        console.warn("There is an unused data object");
        return null;
      } else {
        const childObjectToPush = {
          [subBoxKey]: dataObject[subBoxKey],
          [valueKey.responseKey]: Number(dataObject[valueKey.responseKey]),

        };

        uniqueTootlTipKeys.forEach((key) => {
          childObjectToPush[key] = Number(dataObject[key]);

        });
        transformedDataArray[indexBoxValue].children.push(childObjectToPush);
      }
    });


    return transformedDataArray;
  }
};

export { treeTransformData };
